import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import OrganizationsTable from "@/components/ListTable/OrganizationsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { ListProvider } from "@/modules/list";
import OrganizationAddButton from "@/modules/organization/organization-add-button";

const { Content } = Layout;

const Organizations = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:organizations")} />
      <Content>
        <ListProvider
          endpoint="organizations"
          storageKey={STORAGE_KEYS.ORGANIZATIONS}
        >
          <OrganizationsTable extraActions={<OrganizationAddButton />} />
        </ListProvider>
      </Content>
    </>
  );
};

export default Organizations;
